
<ul class="composite-chart-actions base-tab">
  @for (nav of data.composite_data; track nav) {
    <li class="nav-item">
      <a [class]="nav.widget_name==selectedWidget?'nav-link active':'nav-link'" href="javascript:void(0)" (click)="createWidget(nav)">{{nav.widget_name}}</a>
    </li>
  }

</ul>
@for (item of data.composite_data; track item) {
  <div class="base-tab-content tab-content-v2">
    <ng-template #customComponent></ng-template>
  </div>
}